import tokenStorageService from "./TokenStorageService";
import { getOrgShortName } from "./authservice";

let deeplink = ''

export function setDeeplink(url: string): void {
    deeplink = url;
    tokenStorageService.setItem('attemptedUrl', url);
}

export function clearDeeplink() {
    deeplink = '';
    tokenStorageService.removeItem('attemptedUrl')
}

export function getDeeplinkUrl(): string | null{
    if (!deeplink) {
      deeplink = tokenStorageService.getItem('attemptedUrl') || '';
    }
    let expectedUrl: string | null = null;
    const orgName = getOrgShortName();
    //if the url has an orgshortname and is not a public route then set the expected url
    if (orgName && deeplink) {
      const includesOrgName = deeplink.toLowerCase().includes(orgName.toLowerCase());
      const includesKeywords = ["login", "register", "workspace", "organisation", 'registration', 'force-password-change'].some(
        (keyword) => deeplink.includes(keyword)
      );
      if (includesOrgName && !includesKeywords) {
        expectedUrl = `/${deeplink.split("#/")[1]}`;
      }
    }
  return expectedUrl
}